@if (initializing) {
  <bit-icon
    name="bwi-spinner"
    class="bwi-spin bwi-2x tw-text-muted"
    [ariaLabel]="'loading' | i18n"
  ></bit-icon>
} @else {
  <bit-callout
    *ngIf="this.forceSetPasswordReason !== ForceSetPasswordReason.AdminForcePasswordReset"
    type="warning"
    >{{ "changePasswordWarning" | i18n }}</bit-callout
  >

  <auth-input-password
    [flow]="inputPasswordFlow"
    [email]="email"
    [userId]="userId"
    [loading]="submitting"
    [masterPasswordPolicyOptions]="masterPasswordPolicyOptions"
    [inlineButtons]="true"
    [primaryButtonText]="{ key: 'changeMasterPassword' }"
    (onPasswordFormSubmit)="handlePasswordFormSubmit($event)"
    [secondaryButtonText]="secondaryButtonText()"
    (onSecondaryButtonClick)="logOut()"
  >
  </auth-input-password>
}
